/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dataRequest } from 'mt-react-common/common/reducers/objectCollection/reducer';
import { t } from 'utils/translates';

import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';

import TasksHighlightForm from './forms/TasksHighlightForm';
import TasksFastenForm from './forms/TasksFastenForm';
import TasksUpListForm from './forms/TasksUpListForm';
import TasksService from '../../../mt-react-common/modules/tasks/services/TasksService/TasksService';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

class TasksUpListPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      taskPlace: 0
    };
    this.submitGetTaskPlace();
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    $('#complaint').modal('show');
  }

  setLoading = bool => this.setState({ loading: bool });

  submitGetTaskPlace = () => {
    TasksService.getTaskPlace(this.props.taskModel.id).then(result => {
      if (result.status === 200) {
        this.setState({ ...this.state, taskPlace: result.data });
        // console.log(result.data);
      }
    });
  };

  closeHandler = event => {
    event.preventDefault();
    // eslint-disable-next-line no-undef
    $('#complaint').modal('hide');
    // eslint-disable-next-line no-undef
    $('#complaint').on('hidden.bs.modal', () => {
      this.props.hideTaskUpListPopUp();
    });
  };

  refreshData = () => {
    this.props.updateTask();
    this.submitGetTaskPlace();
  };

  render() {
    return ReactDOM.createPortal(
      <div
        className="modal modal-gray fade"
        data-toggle="modal"
        data-backdrop="static"
        data-keyboard="false"
        id="complaint"
        role="dialog"
        onClick={this.closeHandler}
      >
        <div
          className="modal-dialog"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          {this.state.loading ? <OpacityPreLoader /> : null}
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                className="close close-black"
                href=""
                onClick={this.closeHandler}
              />
              <i className="fa fa-users modal-icon" />
              <h4 className="modal-title">
                {t('Привлечь больше исполнителей')}
              </h4>
              <p>{t('Выберите варианты продвижения задания')}</p>
            </div>
            <div className="modal-body bg-sub">
              <div className="offset_bottom_sm">
                <TasksHighlightForm
                  taskModel={this.props.taskModel}
                  updateTask={this.refreshData}
                  setLoading={this.setLoading}
                />
                <TasksFastenForm
                  taskModel={this.props.taskModel}
                  updateTask={this.refreshData}
                  setLoading={this.setLoading}
                  taskPlace={this.state.taskPlace}
                />
                <TasksUpListForm
                  taskModel={this.props.taskModel}
                  updateTask={this.refreshData}
                  setLoading={this.setLoading}
                  taskPlace={this.state.taskPlace}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-block btn-muted"
                type="button"
                onClick={this.closeHandler}
              >
                {t('Закрыть')}
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }
}

TasksUpListPopUp.contextTypes = {};

TasksUpListPopUp.defaultProps = {};

TasksUpListPopUp.propTypes = {
  // IN
  taskModel: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  hideTaskUpListPopUp: PropTypes.func.isRequired,

  updateTask: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => ({
  updateTask: () =>
    dispatch(dataRequest(tasksCollectionRName, props.taskModel.id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksUpListPopUp);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksUpListPopUpNew/TasksUpListPopUp.js